"use strict";

exports.__esModule = true;
exports.Dashboard = Dashboard;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Theme = require("../../Theme");
var _Widgets = require("../../Widgets");
var _excluded = ["config", "updateLayout"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DashboardContainer = _styledComponents["default"].div.withConfig({
  displayName: "Dashboard__DashboardContainer",
  componentId: "sc-u2pofa-0"
})(["& .", "{padding:0 1rem;height:40px;border-bottom:solid 1px rgba(0,0,0,0.2);color:", ";background:", ";.", "{background-color:", ";}.", "[aria-selected=\"true\"],.", ":not([aria-disabled=\"true\"]):hover{color:", ";}}"], _core.Classes.TAB_LIST, (0, _Theme.val)("ToolbarTextColor"), (0, _Theme.val)("ToolbarBackground"), _core.Classes.TAB_INDICATOR, (0, _Theme.val)("tabIndicatorColor"), _core.Classes.TAB, _core.Classes.TAB, (0, _Theme.val)("tabIndicatorColor"));

/**
 * Render a dashboard based on a configuration object.
 */
function Dashboard(_ref) {
  var config = _ref.config,
    updateLayout = _ref.updateLayout,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var widgets = (0, _react.useContext)(_Widgets.WidgetsContext);
  var updateDashboardWidgetValue = function updateDashboardWidgetValue(path, fieldName, fieldValue) {
    updateLayout(config, path, fieldName, fieldValue);
  };
  return /*#__PURE__*/_react["default"].createElement(DashboardContainer, null, /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.Layout, _extends({
    widgets: widgets.dashboardWidgets,
    config: config,
    updateLayout: updateDashboardWidgetValue
  }, extra)));
}